module.exports = __webpack_public_path__ + "img/b9587d7.jpg";